import React, { Suspense, useState } from "react";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import { TabPanel, useTabStyle } from "App/Component/ui";
import {
  TabRingkasan,
  TabTagihan,
  TabPembayaran,
} from "..";
// import { useContext } from "react";
// import { FormContext } from "../../context/FormContext";
function a11yProps(index) {
  return {
    id: `tab-panel-${index}`,
    "aria-controls": `TabPanel-${index}`,
  };
}

export default function TabMaster({
  setNewDataTabRingkasan,
  rowsTagihan,
  setNewDataTabTagihan,
  loadingTagihan,
  setLoadingTagihan,
  loadingPembayaran,
  setLoadingPembayaran,
  rowsPembayaran,
  setRowsPembayaran,
  setNewDataTabPembayaran,
  setAllNewData,
  setNewDataLog,
}) {
  const classes = useTabStyle();
  const [value, setValue] = useState(0);
  // const { formData } = useContext(FormContext);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Suspense fallback={<div> Loading Tab Master Component...</div>}>
      <div className={classes.root}>
        <div className={classes.rootTab}>
          <AppBar
            position='static'
            classes={{
              root: classes.appbar,
            }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant='fullWidth'
              aria-label='Tabs Input Rekap Tagihan'
              classes={{
                root: classes.tabs,
                flexContainer: classes.fixedTab,
              }}>
              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label='RINGKASAN'
                {...a11yProps(0)}
              />
              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label='TAGIHAN'
                {...a11yProps(1)}
              />
              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label='PEMBAYARAN'
                {...a11yProps(2)}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <TabRingkasan setNewData={setNewDataTabTagihan} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <TabTagihan
              rows={rowsTagihan}
              setNewData={setNewDataTabTagihan}
              loading={loadingTagihan}
              setLoading={setLoadingTagihan}
              setAllNewData={setAllNewData}
              setNewDataLog={setNewDataLog}
            />
          </TabPanel>

          <TabPanel value={value} index={2}>
            <TabPembayaran
              setRows={setRowsPembayaran}
              rows={rowsPembayaran}
              setNewData={setNewDataTabPembayaran}
              loading={loadingPembayaran}
              setLoading={setLoadingPembayaran}
            />
          </TabPanel>
        </div>
      </div>
    </Suspense>
  );
}
